import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const slider = {
	slides: document.querySelectorAll('.js-swiper'),

	init: function() {
		this.swiper();
		this.checkSwiperLockStatus();
	},

	swiper: function() {
		this.slides.forEach((slider) => {
			const nextBtn = slider.querySelector('.swiper-button-next');
			const prevBtn = slider.querySelector('.swiper-button-prev');
			slider
				.querySelector('.js-carousel-arrows')
				?.classList.add('carousel-arrows-wrapper--visible');
			// eslint-disable-next-line no-unused-vars
			const swiper = new Swiper(slider, {
				loop: false,
				slidesPerView: 1,
				spaceBetween: 10,
				navigation: {
					nextEl: nextBtn,
					prevEl: prevBtn,
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 10,
					},
					1200: {
						spaceBetween: 40,
						slidesPerView: 3,
					},
				},
				modules: [Navigation],
			});
		});
	},

	checkSwiperLockStatus: function() {
		this.slides.forEach((slider) => {
			const parent = slider.parentElement;
			const swiperBtnPrev = parent?.querySelector('.swiper-button-prev');
			const link = parent?.querySelector('.intro__link');
			if (swiperBtnPrev?.classList.contains('swiper-button-lock')) {
				link?.classList.add('intro__link--static');
			} else {
				link?.classList.remove('intro__link--static');
			}
		});
	},
};

export default slider;
